import React from 'react';
import GlassPanel from '@/components/ui/GlassPanel';
import { mockTransactions } from '@/data/mock';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const { FiSearch, FiFilter, FiArrowDownLeft, FiArrowUpRight } = FiIcons;

export default function Transactions() {
  return (
    <div className="space-y-6 pb-24 md:pb-8 animate-in fade-in duration-500">
      
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
         <div>
           <h1 className="text-3xl font-bold text-white tracking-tight">Ledger Logs</h1>
           <p className="text-gray-400 text-sm mt-1">Chronological record of all liquidity transfers.</p>
         </div>
      </div>

      <GlassPanel className="p-4 md:p-6">
        <div className="flex flex-col md:flex-row gap-4 mb-6">
          <div className="relative flex-1">
            <SafeIcon icon={FiSearch} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" />
            <input 
              type="text" 
              placeholder="Search merchants, sectors..." 
              className="w-full bg-bb-dark border border-bb-glassBorder rounded-lg pl-10 pr-4 py-2.5 text-sm text-white focus:outline-none focus:border-bb-accent transition-colors font-sans"
            />
          </div>
          <button className="flex items-center justify-center gap-2 bg-bb-dark border border-bb-glassBorder hover:border-gray-500 text-gray-300 px-4 py-2.5 rounded-lg text-xs font-mono uppercase tracking-wider transition-all w-full md:w-auto">
            <SafeIcon icon={FiFilter} /> Filter Logs
          </button>
        </div>

        <div className="overflow-x-auto hide-scrollbar">
          <table className="w-full text-left border-collapse min-w-[600px]">
            <thead>
              <tr className="border-b border-bb-glassBorder">
                <th className="pb-4 pt-2 px-4 text-[10px] font-mono text-gray-500 uppercase tracking-widest font-normal">Date / Time</th>
                <th className="pb-4 pt-2 px-4 text-[10px] font-mono text-gray-500 uppercase tracking-widest font-normal">Entity (Merchant)</th>
                <th className="pb-4 pt-2 px-4 text-[10px] font-mono text-gray-500 uppercase tracking-widest font-normal">Sector</th>
                <th className="pb-4 pt-2 px-4 text-[10px] font-mono text-gray-500 uppercase tracking-widest font-normal text-right">Transfer Amount</th>
              </tr>
            </thead>
            <tbody className="text-sm">
              {mockTransactions.map((tx) => (
                <tr key={tx.id} className="border-b border-bb-glassBorder/50 hover:bg-white/[0.02] transition-colors group">
                  <td className="py-4 px-4 whitespace-nowrap">
                    <div className="text-gray-300 font-mono text-xs">{tx.date}</div>
                    <div className="text-gray-600 font-mono text-[10px] mt-0.5">{tx.time}</div>
                  </td>
                  <td className="py-4 px-4 font-medium text-white">{tx.merchant}</td>
                  <td className="py-4 px-4">
                    <span className="bg-bb-dark border border-gray-700 text-gray-300 text-[10px] font-mono px-2 py-1 rounded">
                      {tx.category}
                    </span>
                  </td>
                  <td className="py-4 px-4 text-right font-mono">
                    <div className={`flex items-center justify-end gap-2 ${tx.amount > 0 ? 'text-emerald-400' : 'text-white'}`}>
                      {tx.amount > 0 ? '+' : ''}{tx.amount.toFixed(2)}
                      <SafeIcon icon={tx.amount > 0 ? FiArrowDownLeft : FiArrowUpRight} className={tx.amount > 0 ? 'text-emerald-400' : 'text-gray-500'} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </GlassPanel>
    </div>
  );
}